import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { getTickets, getTicketPerGameSlotList } from "services/apiTickets";

export function useTickets() {
  const {
    isLoading,
    data: tickets,
    error,
  } = useQuery({
    queryKey: ["tickets"],
    queryFn: getTickets,
  });

  return { isLoading, tickets, error };
}

export function useTicketPerGameSlot(
  gameSlotId,
  size,
  ticketId,
  phoneNumber,
  createdAt
) {
  const [currentPage, setCurrentPage] = useState(0);

  const {
    data,
    error,
    isLoading,
    isFetching,
    refetch: refetchTickets,
  } = useQuery({
    queryKey: ["ticketPerGameSlotList", gameSlotId, currentPage],
    queryFn: async () => {
      return await getTicketPerGameSlotList(
        gameSlotId,
        currentPage,
        size,
        ticketId,
        phoneNumber,
        createdAt
      );
    },
    keepPreviousData: true,
  });

  const tickets = data?.content || [];
  const totalPages = data?.totalPages || 1;

  const hasNextPage = currentPage < totalPages - 1;
  const hasPreviousPage = currentPage > 0;

  const goToNextPage = () => {
    if (hasNextPage) setCurrentPage((prev) => prev + 1);
  };

  const goToPreviousPage = () => {
    if (hasPreviousPage) setCurrentPage((prev) => prev - 1);
  };

  return {
    tickets,
    error,
    isLoading,
    isFetching,
    hasNextPage,
    hasPreviousPage,
    totalPages,
    goToNextPage,
    goToPreviousPage,
    currentPage,
    refetchTickets,
  };
}
